import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center" data-testid="error-boundary-fallback">
          <div className="text-center max-w-md px-8">
            <p className="text-[#C9A962] text-xs tracking-[0.3em] uppercase mb-6">Error inesperado</p>
            <h1 className="text-white text-3xl font-light mb-4" style={{fontFamily: "'Cormorant Garamond', serif"}}>
              Algo salio mal
            </h1>
            <p className="text-zinc-500 text-sm mb-8">
              Ocurrio un error inesperado. Por favor recarga la pagina.
            </p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-boundary-reload-btn"
              className="px-8 py-3 bg-[#C9A962] text-black text-xs tracking-widest uppercase font-medium hover:bg-[#DCC286] transition-colors"
            >
              Recargar pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
